<template>
  <b-card title="General Settings">
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-form
        @submit.prevent
      >
        <b-row>
          <b-card
            title="Application Zoom"
            class="mb-0 mt-0 w-100"
          ><b-row>
            <b-col
              cols="9"
              md="3"
            >
              <b-form-input
                id="browser_zoom"
                v-model="zoom"
                type="range"
                min="65"
                max="100"
                @input="onZoomChange"
              />
            </b-col>
            <b-col cols="3">
              <div class="text-primary font-weight-bolder">
                {{ `${zoom}%` }}
              </div>
            </b-col>
          </b-row>
          </b-card>
        </b-row>
        <b-row>
          <div class="ml-2">
            This slider controls the zoom level of your application content. Decrease for a more broader view.
          </div>
        </b-row>
        <div v-if="isAiFeatureEnabled">
          <b-row class="mt-3">
            <b-card
              title="AI Feature Enable/ Disable Settings"
            >
              <b-form-radio-group
                v-model="aiEnaSelected"
                :options="aiEnaOptions"
                class="demo-inline-spacing"
                value-field="value"
                text-field="text"
                disabled-field="disabled"
                :disabled="radioReadonly"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              The users can Enable or disable AI features for your merchant account using this setting.
            </div>
          </b-row>
          <b-col class="d-flex justify-content-end">
            <b-button
              v-can="'edit-settings'"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              class="custom-button-color mb-2"
              @click="setMerchantSettings"
            >
              Submit
            </b-button>
          </b-col>
        </div>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BForm, BFormInput, BCard, BOverlay, BFormRadioGroup, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const BusinessRepository = RepositoryFactory.get('businessSettings')
const AiSettingRepository = RepositoryFactory.get('aiSetting')
const ResourceRepository = RepositoryFactory.get('resource')

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BCard,
    BOverlay,
    BFormRadioGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      zoom: 100,
      aiEnaSelected: '0',
      aiEnaOptions: [
        { text: 'Enabled', value: true },
        { text: 'Disabled', value: false },
      ],
      aiSettingEnabled: false,
      availabilitySetting: '',
      aiStaffFeatureEnabled: false,
      aiModuleEnabled: false,
      radioReadonly: !this.$can('edit-settings'),
    }
  },
  computed: {
    isAiFeatureEnabled() {
      return ((this.aiModuleEnabled && this.aiSettingEnabled && this.availabilitySetting === 'all') || (this.aiModuleEnabled && this.aiSettingEnabled && this.availabilitySetting === 'selective' && this.aiStaffFeatureEnabled))
    },
  },
  async mounted() {
    this.zoom = localStorage.getItem('browser_zoom') && localStorage.getItem('browser_zoom') !== 'null' ? Number(localStorage.getItem('browser_zoom')) : 100
    await this.readDataforMerchant()
    await this.fetchModules()
    await this.readAiSetting()
  },
  methods: {
    onZoomChange(e) {
      window.parent.document.body.style.zoom = e / 100
      localStorage.setItem('browser_zoom', e)
    },
    async readDataforMerchant() {
      this.loading = true
      try {
        const data = localStorage.getItem('merchant_business_setting') ? JSON.parse(localStorage.getItem('merchant_business_setting')) : (await BusinessRepository.getMerchantSettigs()).data.data
        if (!localStorage.getItem('merchant_business_setting')) localStorage.setItem('merchant_business_setting', JSON.stringify(data))
        this.aiEnaSelected = data.is_ai_active
        this.aiStaffFeatureEnabled = data.is_ai_active_staff
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async fetchModules() {
      try {
        this.loading = true
        const data = localStorage.getItem('module_data') ? JSON.parse(localStorage.getItem('module_data')) : (await ResourceRepository.getModules()).data.data
        if (!localStorage.getItem('module_data')) localStorage.setItem('module_data', JSON.stringify(data))
        const aiSettingModule = data.find(module => module.name === 'AI Setting')
        this.aiModuleEnabled = aiSettingModule ? aiSettingModule.is_active : false
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async readAiSetting() {
      try {
        const data = localStorage.getItem('ai_setting') ? JSON.parse(localStorage.getItem('ai_setting')) : (await AiSettingRepository.getAiSetting()).data.data
        if (!localStorage.getItem('ai_setting')) localStorage.setItem('ai_setting', JSON.stringify(data))
        this.aiSettingEnabled = data.enabled
        this.availabilitySetting = data.availability_setting.preference
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async setMerchantSettings() {
      const setting = {
        is_ai_active: this.aiEnaSelected,
      }
      try {
        const res = await BusinessRepository.getAISettigs(setting)
        if (res.status === 200) {
          this.showSuccessMessage('Successfully Updated')
          localStorage.removeItem('merchant_business_setting')
          window.location.reload()
        } else {
          this.showErrorMessage('Cannot Update Settings')
        }
      } catch (e) {
        this.showErrorMessage('Something went wrong')
      }
    },
  },
}
</script>
